import { IRootState } from "./app/store";

export const selectProjectNo = (state: IRootState) => state.design.projectNo;
export const selectSelectedSpaceNumber = (state: IRootState) => state.design.selectedSpaceNumber;